import { httpRequest } from "../../http";
import { Policy } from "@models/Policy.model";
import { PolicySerializer } from "@models/serializers/policySerializer";

export class CommandListPolicies {
  async run(launchId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/launches/${launchId}/policies/`;

    try {
      const response = await httpRequest<any>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Policy[] {
    const serializer = new PolicySerializer();
    return serializer.deserializeList(data);
  }
}
